<p-toast></p-toast>

<div class="promo-plan-upload-container">
  <h2>Upload Promo Plan Excel</h2>
  <p>Please ensure your Excel file follows the specified template. The first sheet will be read, and it should contain the following columns in order:</p>
  <div class="excel-columns-guide mt-3">
    <p-table [value]="templateColumns" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="250px">
      <ng-template pTemplate="header">
          <tr>
              <th>Column</th>
              <th>Mandatory</th>
              <th>System Validation</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-col>
          <tr>
              <td>{{ col.name }}</td>
              <td>{{ col.mandatory }}</td>
              <td>{{ col.validation }}</td>
          </tr>
      </ng-template>
  </p-table>
  </div>

  <div class="p-field mt-4">
    <div class="flex flex-wrap gap-2">
      <p-fileUpload
        name="promoPlanFile"
        mode="basic"
        chooseLabel="Choose Excel File"
        chooseIcon="pi pi-file-excel"
        [accept]="spreadsheetAcceptTypes"
        [maxFileSize]="maxFileSize"
        [auto]="true"
        [customUpload]="true"
        (uploadHandler)="customUploadHandler($event)"
        [showCancelButton]="false"
        [showUploadButton]="false"
      ></p-fileUpload>
      <a href="assets/templates/promo_plan_upload_template.xlsx" download="promo_plan_upload_template.xlsx">
        <p-button label="Download Template" icon="pi pi-download" styleClass="p-button-secondary"></p-button>
      </a>
    </div>
    <small *ngIf="fileToUpload" class="block mt-1">Selected: {{ fileToUpload.name }}</small>
  </div>

  <div *ngIf="isLoading" class="flex justify-content-center my-3">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" animationDuration=".5s"></p-progressSpinner>
    <p class="ml-2 align-self-center">Parsing Excel file...</p>
  </div>

  <div *ngIf="fileToUpload && !isLoading" class="card mt-4 p-4 bg-white">
    <h4>File Details</h4>
    <div class="file-details">
      <p><strong>File Name:</strong> {{ fileToUpload.name }}</p>
      <p><strong>File Size:</strong> {{ (fileToUpload.size / 1024).toFixed(2) }} KB</p>
      <p><strong>File Type:</strong> {{ fileToUpload.type }}</p>
    </div>

    <div class="mt-4 text-right">
      <button
        *ngIf="!isUploadComplete"
        pButton
        type="button"
        label="Send Promo Plan to Session"
        icon="pi pi-send"
        (click)="sendPromoPlanToBackend()"
        [loading]="isProcessing"
        class="p-button-success p-button-lg"
      ></button>
    </div>
  </div>
</div>
